import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { UilabMatCardModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface CardExample {
    readonly variant: 'outlined' | 'raised';
    readonly label: string;
    readonly description: string;
    readonly appearance: 'outlined' | 'raised';
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-card-examples',
    templateUrl: './card-examples.component.html',
    imports: [
        CommonModule,
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatCardModule,
    ],
})
export class CardExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/docs/components-card--docs`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/card&_a=contents`;

    readonly examples: readonly CardExample[] = [
        {
            variant: 'outlined',
            label: 'Outlined Card',
            description:
                'Use outlined for standard, low-emphasis content grouping.',
            appearance: 'outlined',
            htmlSnippet: `<uilab-mat-card appearance="outlined" direction="column">
    <uilab-mat-card-header>
        <uilab-mat-card-title>Outlined card - Title</uilab-mat-card-title>
        <uilab-mat-card-subtitle>Subtitle</uilab-mat-card-subtitle>
    </uilab-mat-card-header>
    <uilab-mat-card-content>Uilab mat card content 1</uilab-mat-card-content>
</uilab-mat-card>`,
        },
        {
            variant: 'raised',
            label: 'Raised Card',
            description:
                'Use raised for stronger visual emphasis on key content.',
            appearance: 'raised',
            htmlSnippet: `<uilab-mat-card appearance="raised" direction="column">
    <uilab-mat-card-header>
        <uilab-mat-card-title>Raised card - Title</uilab-mat-card-title>
        <uilab-mat-card-subtitle>Subtitle</uilab-mat-card-subtitle>
    </uilab-mat-card-header>
    <uilab-mat-card-content>Uilab mat card content 1</uilab-mat-card-content>
</uilab-mat-card>`,
        },
    ];
}
